import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

import Body from '../../templates/Body/Body';
import { FRONTEND_URL } from '../../utils/globals';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './FAQ.css';

// User guides in different languages
const ENUserGuide = '/user-guides/EN_CinEd_User_Guide.pdf';
const CZUserGuide = '/user-guides/CZ_CinEd_User_Guide.pdf';
const HRUserGuide = '/user-guides/HR_CinEd_User_Guide.pdf';
const LTUserGuide = '/user-guides/LT_CinEd_User_Guide.pdf';
const GRUserGuide = '/user-guides/GR_CinEd_User_Guide.pdf';
const TRUserGuide = '/user-guides/TR_CinEd_User_Guide.pdf';
const SPUserGuide = '/user-guides/SP_CinEd_User_Guide.pdf';
const ITUserGuide = '/user-guides/IT_CinEd_User_Guide.pdf';
const DEUserGuide = '/user-guides/DE_CinEd_User_Guide.pdf';
const ROUserGuide = '/user-guides/RO_CinEd_User_Guide.pdf';
const FRUserGuide = '/user-guides/FR_CinEd_User_Guide.pdf';
const PTUserGuide = '/user-guides/PT_CinEd_User_Guide.pdf';
const BGUserGuide = '/user-guides/BG_CinEd_User_Guide.pdf';
const FIUserGuide = '/user-guides/FI_CinEd_User_Guide.pdf';

const FAQ = [
    {
        question: 'FAQ.Q1',
        answer: 'FAQ.A1',
    },
    {
        question: 'FAQ.Q2',
        answer: 'FAQ.A2',
    },
    {
        question: 'FAQ.Q3',
        answer: 'FAQ.A3',
    },
    {
        question: 'FAQ.Q4',
        answer: 'FAQ.A4',
    },
    {
        question: 'FAQ.Q5',
        answer: 'FAQ.A5',
    },
];

class FAQClass extends React.Component {
    getUserGuide() {
        let userGuide = ENUserGuide;
        switch (i18next.language) {
            case 'US':
                userGuide = ENUserGuide;
                break;
            case 'HR':
                userGuide = HRUserGuide;
                break;
            case 'LT':
                userGuide = LTUserGuide;
                break;
            case 'GR':
                userGuide = GRUserGuide;
                break;
            case 'TR':
                userGuide = TRUserGuide;
                break;
            case 'SP':
                userGuide = SPUserGuide;
                break;
            case 'IT':
                userGuide = ITUserGuide;
                break;
            case 'DE':
                userGuide = DEUserGuide;
                break;
            case 'RO':
                userGuide = ROUserGuide;
                break;
            case 'FR':
                userGuide = FRUserGuide;
                break;
            case 'CZ':
                userGuide = CZUserGuide;
                break;
            case 'PT':
                userGuide = PTUserGuide;
                break;
            case 'BG':
                userGuide = BGUserGuide;
                break;
            case 'FI':
                userGuide = FIUserGuide;
                break;
            default:
                userGuide = ENUserGuide;
        }

        return userGuide;
    }

    render() {
        const { t } = this.props;

        return (
            <Body bodyClass="content" title={`FAQ | CinEd`}>
                <div className="container pageContainer">
                    <h1 className="contactsTitle h1Text">
                        <b>{t('FAQ.Title')}</b>
                    </h1>
                    <h1 className="contactsSubTitle h3Text">{t('FAQ.SubTitle')}</h1>
                </div>

                <div className="accordionWidth">
                    {FAQ.map((item, idx) => (
                        <Accordion key={idx}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <p className="faqQuestion bigText">{t(item.question)}</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p className="faqResponse normalText">{t(item.answer, { frontendUrl: FRONTEND_URL })}</p>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>

                <div className="accordionWidth">
                    <p className="userGuideSection">
                        <span className="boldTxt h5Text">{t('UserGuide.DownloadUG')}</span>
                        <a
                            href={this.getUserGuide()}
                            className="cinedLargeBtn bigText"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span>{t('UserGuide.UGFile')}</span>
                        </a>
                    </p>
                </div>
            </Body>
        );
    }
}

export default withTranslation(['translation'])(FAQClass);
